<template>
  <vs-prompt buttons-hidden	class="large" style="z-index: 52004" :title="`تاريخ ${convertDate}`" :active="active" @close="close">
    <vs-list class="mb-base" v-if="data.length > 0">
      <template v-for="label in eventLabels">
        <template v-if="eventsByLabel(label.value).length > 0">
          <vs-list-header :title="label.text" :color="label.color" :key="label.value"/>
          <vs-list-item v-for="event in eventsByLabel(label.value)" :key="event.id" :title="event.title">
            <feather-icon v-if="isTeacher && event.label === 'event'" @click="removeEvent(event)" icon="TrashIcon" svg-classes="h-6 w-6 cursor-pointer hover:text-danger" />
          </vs-list-item>
        </template>
      </template>
    </vs-list>
    <div v-else class="text-center my-base">
      <feather-icon icon="CalendarIcon" svg-classes="h-16 w-16 text-primary"/>
      <h4 class="mt-2">لا يوجد أحداث في هذه اليوم</h4>
    </div>
    <div class="flex justify-end">
      <vs-button v-if="isTeacher" @click="addEvent" icon="icon-plus" icon-pack="feather" icon-after>حدث</vs-button>
    </div>
  </vs-prompt>
</template>
<script>
    export default {
        name: 'CalendarDate',
        props: {
            data: {
                type: Array,
                default: () => []
            },
            active: {
                type: Boolean,
                required: true
            },
            date: {
                type: Date,
                default: () => new Date
            }
        },
        computed: {
          eventLabels() {
              return this.$store.state.calendar.eventLabels
          },
          convertDate(){
              return `${this.date.getFullYear()}/${this.date.getMonth()+1}/${this.date.getDate()}`
          },
        },
        methods: {
            eventsByLabel(label){
                return this.data.filter(event => event.label === label)
            },
            addEvent(){
                this.$emit('addEvent', this.date)
                this.close()
            },
            removeEvent(event){
                this.$confirmAlert(null, 'هل انت متأكد من حذف الحدث؟', () => {
                    this.$store.dispatch('calendar/removeEvent', event.id)
                    this.$delete(this.data, this.data.indexOf(event))
                })
            },
            close(){
                this.$emit('update:active', false)
            },
        },
    }
</script>
